import { cn } from '#app/utils/misc.tsx'
import { HairlineRule } from './hairline-rule.tsx'

export function EyebrowLabel({
	children,
	tone = 'ink',
	className,
}: {
	children: React.ReactNode
	tone?: 'ink' | 'cream'
	className?: string
}) {
	return (
		<p
			className={cn(
				'flex flex-wrap items-center gap-3 text-eyebrow font-medium uppercase',
				tone === 'cream' ? 'text-cream-ember' : 'text-ember',
				className,
			)}
		>
			<HairlineRule
				className={tone === 'cream' ? 'bg-cream-ember' : undefined}
			/>
			{children}
		</p>
	)
}
